import * as yup from "yup";
import { SystemError } from "../error";
import { Change, NumberIdentity, Version, } from "../value-objects";
import { BaseTenantEntity } from "./base-tenant-entity";
export class BaseOrderEntity extends BaseTenantEntity {
    constructor(value) {
        super(value);
    }
    validator(_) {
        throw new SystemError.NotImplemented("Method not implemented.");
    }
    static schema() {
        return {
            id: NumberIdentity.schema().id,
            tenantId: NumberIdentity.schema().id,
            order: yup.array().of(NumberIdentity.schema().id),
            ...Change.schema(false),
            version: Version.schema(false),
        };
    }
    static getBaseOrderEntityType(v) {
        return {
            id: new NumberIdentity(v.id),
            tenantId: new NumberIdentity(v.tenantId),
            order: v.order.map((o) => new NumberIdentity(o)),
            change: Change.hasChange(v) ? new Change(v) : undefined,
            version: Version.hasVersion(v)
                ? new Version({ version: v.version })
                : undefined,
        };
    }
}
//# sourceMappingURL=base-order-entity.js.map